import { render } from "./FooterPage.vue?vue&type=template&id=5472d45c&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=5472d45c&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/epica/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5472d45c"]])

export default __exports__